import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import uuidv4 from 'uuid';

import PropTypes from 'prop-types';
import { navigate } from '../../actions';
import { openDialog, hideDialog } from '../../actions/index';

import { withStyles } from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Grid from '@material-ui/core/Grid';
import Select from '@material-ui/core/Select';
import CircularProgress from '@material-ui/core/CircularProgress';
import TextField from '@material-ui/core/TextField';

//components:
import NeuriteGrid from '../../components/neurite_grid';

//helpers:
import { getData, postData, putData } from '../../dataLib';

import * as config from '../../constants/configuration';
import { Button } from '@material-ui/core';

const styles = theme => ({
    root: {
        flexGrow: 1,
    },
    formControl: {
        margin: theme.spacing(2),
        minWidth: 120,
    },
    formControlSelect: {
        marginTop: theme.spacing(2),
        marginLeft: theme.spacing(2),
        marginBottom: theme.spacing(2),
        marginRight: theme.spacing(1) * 4,
        minWidth: 120,
    },
    centroSelect: {

    },
    toolbar: {
        display: 'block',
        minHeight: '112px'
    },
    spinnerContainer: {
        width: '95%',
        height: 220,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    spinner: {
        width: '50px !important',
        height: '50px !important',
    }, inputElementLeft: {
        textAlign: "start",
        cursor: "auto"
    },
    inputImporte: {
        margin: theme.spacing(1),
        padding: 0,
        fontSize: 12,
    },
    totales: {
        display: 'flex'
    },
    input: {
        marginLeft: theme.spacing(3),
        marginRight: theme.spacing(1),
        padding: 0,
    },
    button: {
        margin: '15px 8px',
        padding: '10px 4%',
        borderRadius: 0,
        textTransform: 'capitalize',
        color: 'white',
        border: 'none',
        boxShadow: 'none',
    }
});

class EntAlertas extends Component {

    constructor(props) {
        super(props);
        this.state = {
            centroSelected: this.props.centroDiaSelected.centro ? this.props.centroDiaSelected.centro.id : 1,
            maquinaSelected: undefined,
            loadingAlertas: false,
            rows: []
        };
    };

    componentDidMount() {

        if (!this.props.user && config.AUTH) {
            this.props.navigate(""); //go to home page
            return;
        }


    };



    handleSelectCentrosValueChange = (event) => {
        this.setState({ ...this.state, centroSelected: parseInt(event.target.value), maquinaSelected: undefined });
    }

    editIncidencia = (incidencia) => {
        this.props.openDialog('EditIncidencia', {
            incidencia: incidencia,
            maquina: this.state.maquinaSelected,
            okHandler: this.updateIncidencia,
            user: this.props.user ? this.props.user.profile.sub : 1,
        }, uuidv4());
    }

    newIncidencia = () => {
        this.props.openDialog('EditIncidencia', {
            incidencia: {
                id: -1,
                maquinaId: this.state.maquinaSelected.id,
                fecha: new Date(),
                incidencia: '',
                usuarioIncidencia: null,
                fechaDiagnostico: null,
                diagnostico: '',
                usuarioDiagnostico: null,
                fechaResolucion: null,
                resolucion: '',
                usuarioResolucion: null
            },
            maquina: this.state.maquinaSelected,
            okHandler: this.createIncidencia,
            user: this.props.user ? this.props.user.profile.sub : 1,
        }, uuidv4());
    }

    updateIncidencia = (incidencia) => {

        let incURL = 'MaqIncidencias/' + incidencia.id;

        putData(incURL,
            () => {
                const idx = this.state.rows.findIndex(i => i.id === incidencia.id);
                const newRows = this.state.rows.map((row, i) => {
                    if (i === idx) return incidencia;
                    else return row;
                });
                this.setState({ ...this.state, rows: newRows });

            },
            () => {
                this.props.openDialog('SimpleMessage', {
                    message: 'ERROR actualizando incidencia'
                }, uuidv4(), false, 'sm');
            },
            incidencia,
            this.props.user
        );


    }

    createIncidencia = (incidencia, desactivar) => {

        let incURL = 'MaqIncidencias?desactivar=' + desactivar;

        incidencia.id = 0;

        postData(incURL,
            (response) => {
                const newRows = this.state.rows.slice();
                newRows.push(response.data);
                this.setState({ ...this.state, rows: newRows });
            },
            () => {
                this.props.openDialog('SimpleMessage', {
                    message: 'ERROR creando incidencia'
                }, uuidv4(), false, 'sm');
            },
            incidencia,
            this.props.user
        );
    }


    renderAlertasGrid = () => {

        const { classes } = this.props;

        if (this.state.maquinaSelected === undefined) return '';
        else {

            if (this.state.loadingAlertas) {
                return (
                    <div className={classes.spinnerContainer}>
                        <CircularProgress className={classes.spinner} color="primary" />
                    </div>
                );
            }
            else {
                return (
                    <div>
                        <NeuriteGrid
                            id="e_a"
                            columns={[
                                { key: 'fecha', name: 'Fecha', editable: false, dragable: false, type: 'date', width: 120 },
                                { key: 'incidencia', name: 'Incidencia', editable: false, dragable: false, width: 120 },
                                { key: 'fechaDiagnostico', name: 'Fecha Diagnóstico', editable: false, dragable: false, type: 'date', width: 120 },
                                { key: 'diagnostico', name: 'Diagnóstico', editable: false, dragable: false, width: 120 },
                                { key: 'fechaResolucion', name: 'Fecha Resolución', editable: false, dragable: false, type: 'date', width: 120 },
                                { key: 'resolucion', name: 'Resolución', editable: false, dragable: false, width: 120 }
                            ]}
                            rows={this.state.rows}
                            height={300}
                            buttonEdit={true}
                            buttonDelete={false}
                            buttonNew={true}
                            onEditClick={this.editIncidencia}
                            onNewRowClick={this.newIncidencia}
                        />
                    </div>
                )
            }
        }
    }

    selectMaquinaHandler = (maquina) => {
        this.setState({ ...this.state, maquinaSelected: maquina, loadingAlertas: true });
        //get alertas for this maquina
        this.getIncidencias(maquina);

    }


    getIncidencias = (maquina) => {

        let maqURL = 'MaqIncidencias?maquina_id=' + maquina.id;

        getData(maqURL,
            (response) => {
                this.setState({ ...this.state, rows: response.data, loadingAlertas: false });
            },
            (error) => {
                this.props.openDialog('SimpleMessage', {
                    message: 'ERROR obteniendo incidencias'
                }, uuidv4(), false, 'sm');
            },
            this.props.user
        );
    };


    render() {

        const { classes } = this.props;

        return (
            <div className={classes.root}>
                <div className={classes.toolbar} />
                <Grid container direction="row" spacing={5} style={{ display: "flex" }} >
                    <Grid item xs={4}>
                        <FormControl className={classes.formControlSelect} fullWidth>
                            <InputLabel>Centro</InputLabel>
                            <Select className={classes.centroSelect}
                                native
                                fullWidth
                                disabled={[12,14].includes(this.props.userProfile.selectedCentroProfile.iPerfil)}
                                value={this.state.centroSelected}
                                onChange={(event) => this.handleSelectCentrosValueChange(event)}
                                name="centroId"
                            >
                                {this.props.centros.filter(c => c.isGroup === false && c.activo === 1).find(c => c.id === this.state.centroSelected) === undefined ? <option key={'centro_0'} value={0}>{"Seleccione un centro"}</option> : ''}
                                {this.props.centros.filter(c => c.isGroup === false && c.activo === 1).map(centro => {
                                    return (<option key={'centro_' + centro.id} value={centro.id}>{centro.centro}</option>)
                                })}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={1}/>
                    <Grid item xs={4}>
                        <Button variant="contained" color="primary" className={classes.button} onClick={() => {
                            this.props.openDialog('SelectMaquina', {
                                centroId: this.state.centroSelected,
                                user: this.props.user,
                                okHandler: this.selectMaquinaHandler,
                            }, uuidv4());
                        }}>Selecciona máquina</Button>
                    </Grid>
                </Grid>
                <Grid container >
                    <Grid item xs={4} style={{ paddingLeft: "15px" }}>
                        <TextField
                            fullWidth
                            id="outlined-read-only-input-maquina"
                            label="Máquina"
                            value={this.state.maquinaSelected ? this.state.maquinaSelected.regInterno + ' (' + this.state.maquinaSelected.descr + ')' : ''}
                            InputProps={{ classes: { input: classes.inputElementLeft }, readOnly: true }}
                            variant="outlined"
                        />
                    </Grid>
                </Grid>
                <Grid container  style={{ paddingLeft: "8px" }}>
                    <Grid item xs={12} >
                        {this.renderAlertasGrid()}

                    </Grid>

                </Grid>


            </div>
        );
    }
}


EntAlertas.propTypes = {
    //state
    user: PropTypes.object.isRequired,
    //dispatch
    navigate: PropTypes.func.isRequired,

};

function mapStateToProps(state) {
    return {
        user: state.oidc.user,
        centroDiaSelected: state.centroDiaSelected,
        centros: state.centros.centros,
        userProfile: state.userProfile,
    };
};

function mapDispathToProps(dispatch) {
    return bindActionCreators({
        openDialog,
        hideDialog,
        navigate
    }, dispatch);
};

export default connect(
    mapStateToProps,
    mapDispathToProps
)(withStyles(styles, { withTheme: true })(EntAlertas));